import { combineReducers } from 'redux';
import { clientReducer } from './client';
import { familyReducer } from './family';
import { programReducer } from './program';
import { locationReducer } from './location';
import { referralReducer } from './referral';
import { notificationReducer } from './notifications';
import { userReducer } from './user';
import { usersReducer } from './users';
import { dynamicclientReducer } from './dynamicclient';

 const appReducer = combineReducers({
    client: clientReducer,
    family: familyReducer,
    referral: referralReducer,
    notifications: notificationReducer,
    program: programReducer,
    programLocation: locationReducer,
    user: userReducer,
    users: usersReducer,
    dynamicclient: dynamicclientReducer
});

//Root reducer that resets the state on logout
export const rootReducer = (state: any, action: any) => {
    if (action.type === 'LOGOUT') {
        state = undefined; // Reset the state on logout
    }
    return appReducer(state, action);
}
export type AppState = ReturnType<typeof rootReducer>;
